import React, {useState, useEffect} from 'react'
import {Alert, Button, Form, Input, Modal, notification, Radio, Select} from "antd"
import queryString from "query-string"
import {createBatchByIds, listLevels, listPartner} from "../../../services/api/3dApi"

const {Option} = Select

const BatchRecycle = (props) => {
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [isOpen, setIsOpen] = useState(false)
    const [validate, setValidate] = useState('')
    const [user, setUser] = useState('')
    const [level, setLevel] = useState('1')
    const [levels, setLevels] = useState([])
    const [partner, setPartner] = useState('')
    const [partners, setPartners] = useState([])
    const [errLevels, setErrLevels] = useState('')
    const [errPartner, setErrPartner] = useState('')

    const showModal = () => {
        setLoading(false)
        setIsOpen(true)
        setError('')
        setValidate('')
    }

    const closeModal = () => {
        setLoading(false)
        setIsOpen(false)
        setError('')
        setValidate('')
    }

    const handleChangeInput = (e) => {
        const {value} = e.target

        setUser(value)
    }

    const handleChange = (e) => {
        const {value} = e.target

        setLevel(value)
    }

    const handleChangePartner = (value) => {
        setPartner(value)
    }

    const onRecycleBatch = async () => {
        setLoading(true)
        setError('')

        try {
            const {selectedBatchId, getBatchesError} = props

            if (user === undefined || user === '') {
                setLoading(false)
                setValidate('Vui lòng nhập vào người tái tạo lô.')

                return
            }

            const params = {
                ids: selectedBatchId,
                user_create: user,
                level: level,
                partner: partner
            }

            const {data: response} = await createBatchByIds(params)

            const {success, error, data} = response

            if (!success) {
                setLoading(false)
                setError(error)

                return
            }

            setLoading(false)
            closeModal()
            getBatchesError()

            if (data.batch._id) {
                const win = window.open(`/batches/${data.batch._id}`, "_blank")
                win.focus()
            }

            if (!!data.errorMessages && data.errorMessages.length > 0) {
                notification.error({
                    message: 'Lỗi',
                    description: data.errorMessages.map((item, index) => {
                        return <p className='mb-0' key={index}>{item}</p>
                    })
                })
            }
        } catch (e) {
            setLoading(false)
            setError(e.message)
        }
    }

    const fetchLevels = async () => {
        try {
            const {data: response} = await listLevels()

            const {success, error, data} = response

            if (!success) {
                setLevels(error)

                return
            }

            setErrLevels('')
            setLevels(data)
        } catch (e) {
            setErrLevels(e.message)
        }
    }

    const fetchPartners = async () => {
        try {
            const payload = {type: 'print_partner'}
            const query = queryString.stringify(payload)

            const {data: response} = await listPartner(query)

            const {success, error, data} = response

            if (!success) {
                setErrPartner(error)

                return
            }

            setErrPartner('')
            setPartners(data.partners)
        } catch (e) {
            setErrPartner(e.message)
        }
    }

    useEffect(() => {
        if (isOpen) {
            fetchLevels()
            fetchPartners()
        }
    }, [isOpen])

    return (
        <div className="BatchRecycle">
            <Button loading={loading}
                    onClick={showModal}
            >
                Tái tạo lô
            </Button>
            <Modal
                visible={isOpen}
                title="Tái tạo lô"
                onOk={onRecycleBatch}
                onCancel={closeModal}
                footer={[
                    <Button key="back" onClick={closeModal}>
                        Hủy
                    </Button>,
                    <Button key="submit" type="primary" loading={loading} onClick={onRecycleBatch}>
                        Tái tạo
                    </Button>
                ]}
            >
                {error && <Alert message={error} type='error' className='mb-3'/>}

                <Form.Item
                    label='Tên người tái tạo lô'
                    validateStatus={validate && 'error'}
                    help={validate}
                >
                    <Input value={user} onChange={handleChangeInput}/>
                </Form.Item>

                <Form.Item
                    label='Chọn đối tác'
                    validateStatus={errPartner && 'error'}
                    help={errPartner}
                >
                    <Select 
                        onChange={handleChangePartner} 
                        defaultValue={partner}
                        dropdownClassName='custom-select-partner'
                    >
                        <Option value=''>---Hãy chọn một đối tác---</Option>
                        {
                            partners.length > 0 && partners.map(item => {
                                return <Option key={item._id} value={item._id}>{item.name}</Option>
                            })
                        }
                    </Select>
                </Form.Item>

                <Form.Item
                    label='Độ ưu tiên của lô'
                    validateStatus={errLevels && 'error'}
                    help={errLevels}
                >
                    <Radio.Group onChange={handleChange} defaultValue={level}>
                        {
                            levels.length > 0 && levels.map(item => {
                                return <Radio key={item.key} value={item.key}>{item.value}</Radio>
                            })
                        }
                    </Radio.Group>
                </Form.Item>
            </Modal>
        </div>
    )
}

export default BatchRecycle
